module.exports = __webpack_public_path__ + "img/2.c1b32fea.jpeg";